import { UserModel } from "../user.model";

export class AddressesModel {
    active: Boolean;
    address1: String;
    address2: String;
    companyBillingId: Number;
    companyId: Number;
    isDefault: Boolean;
    memberId: Number;
    taxAddressId: Number;
    taxNumber: String;
    title: String;
    costCenterCode: String;
    costCenterName: String;
}

export class AddressesUserProfileModel {
    active?: Boolean;
    address: String;
    companyId?: Number;
    isDefault?: Boolean;
    taxAddressId: Number;
    taxNumber: String;
    title: String;
}

export class MemberModel {
    companyTitle: String;
    companyTravelExpense: String;
    companyWebsite: String;
    email: String;
    fullName: String;
    memberId: Number;
    phone: String;
    position: String;
    status: Boolean;
}

export class staffMemberModel {
    member: MemberModel;
}

export class StaffModel {
    fullName: String;
    signatureImagePath: String;
    staffMember: staffMemberModel;
    status: Boolean;
}

export class UserInfoModel {
    birthDate: string;
    datetimesubmit: Number;
    userId: Number;
    email: String;
    fullName: String;
    picture: String;
    companyUser: CompanyUserModel;
    status: Boolean;
    countryCallingCode: String;
    telephone: String;
    timeOfBirth: string;

    constructor(user: UserModel, langId: string) {
        this.birthDate = user.birthdate;
        this.userId = user.userId;
        this.email = user.email;
        this.fullName = user.fullName;
        this.picture = user.profileImage;
        this.countryCallingCode = user.countryCallingCode;
        this.telephone = user.telephone;
        this.companyUser = new CompanyUserModel(user, langId);
        this.timeOfBirth = user.timeOfBirth;
    }
}

export class ProfileModel {
    userProfile: UserInfoModel;
    addresses: AddressesUserProfileModel[];
}

export class CompanyUserModel {
    position: String;
    employeeId: String;
    companyTitle: String;
    status: Boolean;

    constructor(user: UserModel, langId: string) {
        this.position = user.position;
        this.companyTitle = langId === '1' ? user.companyTitleEn : user.companyTitleTh;
    }
}

export class CreditTermModel {
    allow: Boolean;
    billing: AddressesModel[];
    costCenter: AddressesModel[];
}



// WEBPACK FOOTER //
// ./src/app/model/profile/profile.model.ts